import React, {useState, useEffect } from 'react';
import { Controller, useForm } from "react-hook-form";
import ReactQuill from "react-quill";
import { formats, modules } from "../../utils/editor-tool-options";
import TextEditor from '../../utils/text-editor';
import Sidebars from '../../components/sidebars/Sidebars';
import Header from '../../components/header/Header';
import Footer from '../../components/footer/Footer';
import { toast } from "react-toastify";
import { GetUrl } from '../../config/GetUrl';
import { useGetStaticContentByTypeQuery, useUpdateStaticContentMutation } from '../../Services/StaticContentApi';

const StorePolicy = () => {
  const { control, handleSubmit, formState: { errors }, setValue } = useForm();

  // Fetch existing terms content
  const { data: contentData } = useGetStaticContentByTypeQuery("store-policy");
  const [updateContent] = useUpdateStaticContentMutation();
    const [image, setImage] = useState(null);
 const handleImageChange = (e) => {
    setImage(e.target.files[0]);
  };
  // Pre-fill form when data arrives
  useEffect(() => {
   console.log(contentData)
    if (contentData?.data?.contents) {
      setValue("content", contentData.data.contents);
      setImage(contentData.data.fileUrl);
    }
  }, [contentData, setValue]);

  const onSubmit = async (data) => {
    const formData = new FormData();
    formData.append("type", "store-policy");
    formData.append("contents", data.content);
    if (image) {
      formData.append("fileUrl", image);
    }
    try {
      const res = await updateContent(formData);
      console.log("res", res);
      if (res?.data?.statusCode === 200) {
      toast.success("UPDATED SUCCESSFULLY");
      } else {
        toast.error("Failed to update content");
      }
    } catch (err) {
      toast.error("Error occurred while updating content");
    }
  };

  return (
    <>
      <Sidebars />
      <Header />
      <main id="main" className="content main mt-0 h-100 min-vh-80">
        <div className="container-fluid allCards-new mobile-image-width mobile-px-0">
          <div className="row">
            <div className="col-md-12">
              <div className="clearfix mt-3 mb-4">
                <div className="float-start">
                  <h2 className="text-contact">Store Policy</h2>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-body">
                   <div>
                                      <div className="mb-4">
                                        <label className="form-label">Image/Video</label>
                                        <input
                                          type="file"
                                          className="form-control"
                                          onChange={handleImageChange}
                                        />
                                        <div className="my-4">
                                          <div className="position-relative">
                                            <img src={image?.name ? URL.createObjectURL(image) : image} alt="Preview" height={200} />
                  
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                  <form className="form-design" onSubmit={handleSubmit(onSubmit)}>
                     <TextEditor />
                    <Controller
                      name="content"
                      rules={{ required: "Field is required." }}
                      control={control}
                      render={({ field: { onChange, value }, fieldState: { error } }) => (
                        <>
                          <ReactQuill
                            theme="snow"
                            value={value || ''}
                            onChange={(val) => val === "<p><br></p>" ? onChange('') : onChange(val)}
                            placeholder="Enter Terms & Conditions"
                            modules={modules}
                            formats={formats}
                          />
                          {error?.message && <span className="err-msg text-danger">{error.message}</span>}
                        </>
                      )}
                    />
                    <div className="col-md-2 mt-3">
                      <button type="submit" className="btn btn-linear btn-block w-100">Submit</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};
export default StorePolicy